import styled, { css } from 'styled-components';
import { Tag } from '@ontruck/orc';
import { skinsGroupage } from 'modules/journey/card/styled';

const tagStyles = () => css`
  background-color: ${skinsGroupage.groupage0};
  color: var(--white);
  border: none;

  svg {
    fill: var(--white);
  }
`;

const StyledFrozenTag = styled(Tag)`
  ${tagStyles};
`;

export default StyledFrozenTag;
